const wowApp = require('angular').module('wowApp.shop');

wowApp.service('LoadingIndicatorService', [require('./loading-indicator-service')]);
wowApp.directive('wowLoadingIndicator', ['$timeout', 'LoadingIndicatorService', require('./loading-indicator-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/loadingindicator/index.js
 **/